import { createEvent, createStore } from 'effector'
import { createGate } from 'effector-react'

import {
  DEFAULT_JINGLES_LIST_PAGE_TAB,
  type JinglesListPageTabsKeys,
} from '../lib/tabs'

// Gate
export const JinglesListPageGate = createGate()

// Tab
export const jinglesListPageTabChanged = createEvent<JinglesListPageTabsKeys>()
export const $jinglesListPageTab = createStore<JinglesListPageTabsKeys>(
  DEFAULT_JINGLES_LIST_PAGE_TAB,
).on(jinglesListPageTabChanged, (_, payload) => payload)
